export const basePath = '/conversations/summaries'

const summariesRoutes = {
  root: basePath,
}

export default summariesRoutes
